import React from 'react';
import PropTypes from 'prop-types';
import {ControlLabel, FormGroup} from "react-bootstrap";
import UserService from "../../../services/UserService";
import IntegrationUserService from "../IntegrationUserService";
import CompanyService from "../../../services/CompanyService";
import CompanySelector from "../../../component/Company/CompanySelector";
import FormButtons from "../../../component/Form/FormButtons";
import Notify from "../../../services/Notify";
import Loading from "../../../component/Loading/Loading";
import Box from "../../../component/Box/Box";

class IntegrationUserForm extends React.Component {

  userService = new IntegrationUserService();
  companyService = new CompanyService();

  constructor(props) {
    super(props);
    const showCompany = UserService.hasRoles([UserService.ROLE_SUPER]);
    this.state = {showCompany};
  }

  componentWillMount() {
    const {match} = this.props;
    const id = match.params.id;
    if (id) {
      const state = this.state;
      state.loading = true;
      this.setState(state);
      this.userService.findById(id).then(
          data => {
            this.companyService.findById(data.company.id).then(company => {
              data.company = company;
              this.setState({loading: false, entity: data});
            }, (error) => {
              if (error.response.status === 404) {
                state.message = 'Empresa não encontrada!';
              } else {
                state.message = 'Erro inesperado!';
                Notify.error('Falha o buscar entidade!', error)
              }
              this.setState(state);
            });

          },
          error => {
            const state = {loading: false};
            if (error.response.status === 404) {
              state.message = 'Entidade não encontrada!';
            } else {
              state.message = 'Erro inesperado!';
              Notify.error('Falha o buscar entidade!', error)
            }
            this.setState(state);
          }
      )
    }
  }

  submitForm() {
    const {entity, showCompany} = this.state;
    const existingEntity = entity && entity.id;
    const entityVersion = entity && entity.version;
    const company = showCompany ? {id: this.companyId} : null;

    const entityToSave = {
      id: existingEntity,
      name: this.name.value && this.name.value.trim(),
      company,
      version: entityVersion || null
    };

    this.setState({loading: true, message: 'Salvando...'});
    this.userService.save(entityToSave).then(
        () => {
          this.props.history.goBack();
          Notify.success('Entidade salva');
        },
        (error) => {
          Notify.error('Falha ao salvar entidade:', error);
          this.setState({loading: true, entity: entityToSave, message: 'Salvando...'});
        });
  }

  render() {
    const {loading, entity, message, showCompany = false} = this.state;
    const isNew = entity && entity.id;
    if (loading) {
      return <Loading/>
    }
    if (message) {
      return <h2>{message}</h2>
    }
    return (
        <Box info>
          <form ref={form => (this.form = form)} onSubmit={event => {
            event.preventDefault();
            this.submitForm()
          }}>

            <FormGroup>
              <ControlLabel>Nome</ControlLabel>
              <input type="text" className="form-control" placeholder="Nome completo" required
                     name="first" ref={value => this.name = value} defaultValue={entity && entity.name}/>
            </FormGroup>

            {isNew ? '' : <div>
              <FormGroup>
                <ControlLabel>Token</ControlLabel>
                <input type="text" className="form-control" disabled={true} defaultValue={entity && entity.token}/>
              </FormGroup>
            </div>}

            {showCompany ?
                <CompanySelector readonly={(entity && entity.company.id ? true : false)}
                                 setValue={companyId => this.companyId = companyId}
                                 defaultValue={entity && entity.company.id}/> : ''
            }

            <FormButtons history={this.props.history}/>
          </form>
        </Box>);
  }
}

IntegrationUserForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default IntegrationUserForm;



// WEBPACK FOOTER //
// ./src/user/integration/component/IntegrationUserForm.js